import {IS_FISRT_TYPE} from './../type/index';

export const changeFirstLoad = () => ({
  type: IS_FISRT_TYPE.CHANGE_IS_FISRT,
  payload: false,
})
